import React, { useState, useEffect } from "react";
import {
  BaseButtons,
  DropDownWithDisplay,
  TextInputField,
} from "../../../../../common-components";
import { colors } from "../../../../../../themes/Colors";
import VehicleCard from "../vehicle-card/VehicleCard";
import useWindowDimensions from "../../../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import ImageUploadAWS from "../../../../../user/components/image-upload/ImageUploadAWS";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];
const dummyMakes = [
  { name: "BMW", imageLink: "link here" },
  { name: "VW", imageLink: "link here" },
  { name: "TOYATA", imageLink: "link here" },
  { name: "HYUNDAI", imageLink: "link here" },
  { name: "AUDI", imageLink: "link here" },
  { name: "GWM", imageLink: "link here" },
  { name: "MERCEDES", imageLink: "link here" },
  { name: "JEEP", imageLink: "link here" },
  { name: "ALPHA ROMEO", imageLink: "link here" },
  { name: "FIAT", imageLink: "link here" },
  { name: "DODGE", imageLink: "link here" },
  { name: "FORD", imageLink: "link here" },
];

const dummySeries = [
  { name: "320i", make: "bmw", imageLink: "link here" },
  { name: "320d", make: "bmw", imageLink: "link here" },
  { name: "180i", make: "bmw", imageLink: "link here" },
  { name: "180d", make: "bmw", imageLink: "link here" },
  { name: "m", make: "bmw", imageLink: "link here" },
  { name: "m3", make: "bmw", imageLink: "link here" },
  { name: "m1", make: "bmw", imageLink: "link here" },
  { name: "m2", make: "bmw", imageLink: "link here" },
  { name: "m4", make: "bmw", imageLink: "link here" },
];

const ManageVehiclePopUp = ({
  activeView,
  setActiveView,
  // SubmitHandler,
  regsitrationNr,
  setRegistrationNr,
  vinNr,
  setVinNr,
  licenceNr,
  setLicenceNr,
  engineNr,
  setEngineNr,
  make,
  setMake,
  series,
  setSeries,
  selectedVehicle,
  tableDisplay,
  auth,
  setSelectedVehicle,
  setMessage,
  setPopUpTitle,
  setToastPop,
  setRefresh,
  refresh,
  setLoading,
}) => {
  const { width, height } = useWindowDimensions();
  const [selectedMake, setSelectedMake] = useState(false);
  const [selectedSeries, setSelectedSeries] = useState("");
  const [opened, setOpened] = useState(null);
  const [vehicleOwner, setVehicleOwner] = useState(null);
  const [linkedUserIdNumber, setLinkedUserIdNumber] = useState("");

  const [vehicleParticularsCheckData, setVehicleParticularsCheckData] =
    useState(null);

  // vehicle particulars
  const [licenceNumber, setLicenceNumber] = useState("");
  const [chassisNumber, setChassisNumber] = useState("");
  const [vehicleRegisterNumber, setVehicleRegisterNumber] = useState("");
  const [engineNumber, setEngineNumber] = useState("");
  const [previousLicenceNumber, setPreviousLicenceNumber] = useState("none");
  const [prepreviousLicenceNumber, setPrePreviousLicenceNumber] =
    useState("none");
  const [modelDerivitive, setModelDerivitive] = useState("");
  const [tareKg, setTareKg] = useState("");
  const [grossVehicleMassKg, setGrossVehicleMassKg] = useState("");
  const [category, setCategory] = useState("");
  const [colour, setColour] = useState("");
  const [driven, setDriven] = useState("");
  const [specialClassifications, setSpecialClassifications] = useState("");
  const [description, setDescription] = useState("");
  const [licenceExpiry, setLicenceExpiry] = useState("");
  const [usage, setUsage] = useState("");
  const [licenceDiscNumber, setLicenceDiscNumber] = useState("");
  const [vehicleState, setVehicleState] = useState("");
  const [engineCapacity, setEngineCapcity] = useState("");
  const [roadWorthStatus, setRoadWorthyStatus] = useState("");
  const [localLicenceFee, setLocalLicenceFee] = useState("");
  const [policeMark, setPoliceMark] = useState("");
  const [localityOfVehicleRecord, setLocalityOfVehicleRecord] = useState("");
  const [policeClearanceStatus, setPoliceClearanceStatus] = useState("");
  const [ownerType, setOwnerType] = useState("");
  const [ownerStatus, setOwnerStatus] = useState("");
  const [ownershipStartDate, setOwnershipStartDate] = useState("");
  const [name, setName] = useState("");
  const [identificationType, setIdentificationType] = useState("");
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [address, setAddress] = useState("");

  const [reportDate, setReportDate] = useState("");
  const [documentDate, setDocumentDate] = useState("");

  const [vehicleDataTabDisplay, setVehicleDataTabDisplay] =
    useState("standard");

  const [imageData, setImageData] = useState(null);

  const [file, setFile] = useState(null);

  const [imageError, setImageError] = useState("");

  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setFile(file);
  };

  const GetVehicleOwner = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/getVehicleOwner",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: selectedVehicle.vehicleOwnerUuid,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setVehicleOwner(respnseData.vehicleOwner);
      }
    } catch (err) {
      // setPopUpTitle("FAILURE");
      // setMessage(
      //   "Error occured contact support but make sure you have network first"
      // );
      // setToastPop(true);
    }
  };
  const getVehicleParticulars = async () => {
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/enatis/getVehicleParticulars",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            registerNumber: selectedVehicle.registerNr,
          }),
        }
      );

      const respnseData = await response.json();
      console.log("response get check", respnseData);
      if (respnseData.success) {
        setVehicleParticularsCheckData(respnseData.vehicleSearched);
        setLicenceNumber(respnseData.vehicleSearched.licenceNumber);
        setChassisNumber(respnseData.vehicleSearched.chasisVinNumber);
        setEngineNumber(respnseData.vehicleSearched.engineNumber);
        setVehicleRegisterNumber(
          respnseData.vehicleSearched.vehicleRegisterNumber
        );
        setTareKg(respnseData.vehicleSearched.tareKg);
        setGrossVehicleMassKg(respnseData.vehicleSearched.grossVehicleMass);
        setModelDerivitive(respnseData.vehicleSearched.modelDerivitive);
        setCategory(respnseData.vehicleSearched.category);
        setColour(respnseData.vehicleSearched.color);
        setDriven(respnseData.vehicleSearched.driven);
        setSpecialClassifications(
          respnseData.vehicleSearched.specialClassifications
        );
        setDescription(respnseData.vehicleSearched.description);
        setUsage(respnseData.vehicleSearched.usage);
        setLicenceExpiry(respnseData.vehicleSearched.licenceExpiry);
        setVehicleState(respnseData.vehicleSearched.vehicleState);
        setLicenceDiscNumber(respnseData.vehicleSearched.licenceDiscNumber);
        setRoadWorthyStatus(respnseData.vehicleSearched.roadWorthyStatus);
        setEngineCapcity(respnseData.vehicleSearched.engineCapacity);
        setPoliceMark(respnseData.vehicleSearched.policeMark);
        setLocalLicenceFee(respnseData.vehicleSearched.localLicenceFee);
        setLocalityOfVehicleRecord(
          respnseData.vehicleSearched.localityOfVehlceRecord
        );
        setPoliceClearanceStatus(
          respnseData.vehicleSearched.policeClearenceStatus
        );
        setOwnerType(respnseData.vehicleSearched.ownerType);
        setOwnerStatus(respnseData.vehicleSearched.ownerStatus);
        setName(respnseData.vehicleSearched.name);
        setIdentificationNumber(
          respnseData.vehicleSearched.identifcationNumber
        );
        setIdentificationType(respnseData.vehicleSearched.identifcationType);
        setOwnershipStartDate(respnseData.vehicleSearched.ownershipStartDate);
        setAddress(respnseData.vehicleSearched.address);
        setReportDate(respnseData.vehicleSearched.reportDate);
        setDocumentDate(respnseData.vehicleSearched.documentDate);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");
      console.log("direct failure", err);
      setMessage(
        "Error occured contact support but make sure you have network first"
      );
      setToastPop(true);
    }
  };
  const createNewParticulars = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/enatis/addVehicleParticulars",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            addedBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
            editedBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,

            // specific vehicle fields to 164B
            licenceNumber: licenceNumber,
            vehicleRegisterNumber: selectedVehicle.registerNr,
            chasisVinNumber: chassisNumber,
            engineNumber: engineNumber,
            previousLicenceNumber: previousLicenceNumber,
            make: selectedMake,
            series: selectedSeries,
            modelDerivitive: modelDerivitive,
            category: category,
            driven: driven,
            description: description,
            usage: usage,
            vehicleState: vehicleState,
            roadWorthyStatus: roadWorthStatus,
            policeMark: policeMark,
            tareKg: tareKg,
            grossVehicleMass: grossVehicleMassKg,
            color: colour,
            specialClassifications: specialClassifications,
            licenceExpiry: licenceExpiry,

            licenceDiscNumber: licenceDiscNumber,
            engineCapacity: engineCapacity,
            localLicenceFee: localLicenceFee,
            localityOfVehlceRecord: localityOfVehicleRecord,

            //owner info
            policeClearenceStatus: policeClearanceStatus,
            ownerStatus: ownerStatus,
            ownerType: ownerType,
            ownershipStartDate: ownershipStartDate,
            name: name,
            identifcationType: identificationType,
            identifcationNumber: identificationNumber,
            address: address,

            // date requested doc
            documentDate: documentDate,
            reportDate: reportDate,
          }),
        }
      );

      const respnseData = await response.json();
      console.log("response", respnseData);
      if (respnseData.success) {
        setLoading(false);

        setActiveView("catalog");
        setVehicleDataTabDisplay("standard");
        setVehicleOwner(null);
        setSelectedVehicle(null);
        setMessage(respnseData.success);
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setRefresh(refresh ? false : true);
      }
    } catch (err) {
      setLoading(false);
      setPopUpTitle("FAILURE");
      setMessage(err);
      setToastPop(true);
    }
  };

  const updateNewParticulars = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/enatis/updateVehicleParticulars",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            editedBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,

            // specific vehicle fields to 164B
            licenceNumber: licenceNumber,
            vehicleRegisterNumber: selectedVehicle.registerNr,
            chasisVinNumber: chassisNumber,
            engineNumber: engineNumber,
            previousLicenceNumber: previousLicenceNumber,
            make: selectedMake,
            series: selectedSeries,
            modelDerivitive: modelDerivitive,
            category: category,
            driven: driven,
            description: description,
            usage: usage,
            vehicleState: vehicleState,
            roadWorthyStatus: roadWorthStatus,
            policeMark: policeMark,
            tareKg: tareKg,
            grossVehicleMass: grossVehicleMassKg,
            color: colour,
            specialClassifications: specialClassifications,
            licenceExpiry: licenceExpiry,

            licenceDiscNumber: licenceDiscNumber,
            engineCapacity: engineCapacity,
            localLicenceFee: localLicenceFee,
            localityOfVehlceRecord: localityOfVehicleRecord,

            //owner info
            policeClearenceStatus: policeClearanceStatus,
            ownerStatus: ownerStatus,
            ownerType: ownerType,
            ownershipStartDate: ownershipStartDate,
            name: name,
            identifcationType: identificationType,
            identifcationNumber: identificationNumber,
            address: address,

            // date requested doc
            documentDate: documentDate,
            reportDate: reportDate,
            docImageId: "none",
          }),
        }
      );

      const respnseData = await response.json();
      console.log("response", respnseData);
      if (respnseData.success) {
        setLoading(false);

        setActiveView("catalog");
        setVehicleDataTabDisplay("standard");
        setVehicleOwner(null);
        setSelectedVehicle(null);
        setMessage(respnseData.success);
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setRefresh(refresh ? false : true);
      } else {
        setLoading(false);
        setMessage(respnseData.message);
        setToastPop(true);
        setPopUpTitle("FAILURE");
        setRefresh(refresh ? false : true);
      }
    } catch (err) {
      setLoading(false);
      setPopUpTitle("FAILURE");
      setMessage(err);
      setToastPop(true);
    }
  };

  const updateVehicleBasic = async () => {
    setLoading(true);
    console.log("update");
    try {
      const response = await fetch(
        // process.env.REACT_APP_BACKEND_URL +
        //   "/enatis/editEnatisMAsterVehicleData",
        "https://driverfrienddatabase-h2aa.onrender.com/enatis/editEnatisMAsterVehicleData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: selectedVehicle._id,
            registerNr: regsitrationNr,
            vinNr: vinNr,
            licenceNr: licenceNr,
            engineNr: engineNr,
            make: selectedMake,
            series: selectedSeries,
            addedBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
            editedBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
            linkedIDnumber: linkedUserIdNumber,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setToastPop(true);
        setMessage("You have Updates vehicle");
        setPopUpTitle("SUCCESS");
        setActiveView("catalog");
        setLoading(false);
        setRefresh(refresh ? false : true);
      } else {
        setToastPop(true);
        setMessage(respnseData.error);
        setPopUpTitle("FAILURE");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };
  useEffect(() => {
    if (selectedVehicle && tableDisplay === "driverVehicles") {
      GetVehicleOwner();
    } else {
      if (selectedVehicle) {
        setSelectedSeries(selectedVehicle.series);
        setSelectedMake(selectedVehicle.make);
        setLicenceNumber(selectedVehicle.licenceNr);
        setVehicleRegisterNumber(selectedVehicle.registerNr);
        setChassisNumber(selectedVehicle.vinNr);
        setEngineNumber(selectedVehicle.engineNr);
        if (selectedVehicle.linkedIDnumber) {
          setLinkedUserIdNumber(selectedVehicle.linkedIDnumber);
        } else {
          setLinkedUserIdNumber("none");
        }
        getVehicleParticulars();
      }
    }
  }, [selectedVehicle]);
  return (
    <div
      style={{
        height: activeView === "manage" ? "100%" : 0,
        width: "100%",
        //   borderStyle: "solid",
        // borderRadius: 15,
        //   borderColor: colors.primaryBlue,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        transition: "height 0.3s",
        position: "absolute",
        bottom: 0,
        backgroundColor: colors.white,
      }}
    >
      {vehicleDataTabDisplay === "standard" ? (
        <div
          style={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                flex: 0.5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",

                height: "100%",
              }}
            >
              {tableDisplay === "driverVehicles" ? null : (
                <div
                  style={{
                    marginTop: 120,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: 10,
                  }}
                >
                  ENATIS VEHICLE DATA
                </div>
              )}
              <div
                style={{
                  height: 200,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: tableDisplay === "driverVehicles" ? 10 : 0,
                }}
              >
                {tableDisplay === "driverVehicles" ? (
                  <VehicleCard
                    registrationNr={
                      selectedVehicle
                        ? selectedVehicle.registerNumber
                        : "loading"
                    }
                    vin_nr={
                      selectedVehicle ? selectedVehicle.vinNumber : "loading"
                    }
                    licenceNr={
                      selectedVehicle
                        ? selectedVehicle.liscenseNumber
                        : "loading"
                    }
                    engineNr={
                      selectedVehicle ? selectedVehicle.engineNumber : "loading"
                    }
                    make={selectedVehicle ? selectedVehicle.make : "loading"}
                    series={
                      selectedVehicle ? selectedVehicle.series : "loading"
                    }
                    notList={true}
                  />
                ) : (
                  <VehicleCard
                    registrationNr={
                      selectedVehicle ? selectedVehicle.registerNr : "loading"
                    }
                    vin_nr={selectedVehicle ? selectedVehicle.vinNr : "loading"}
                    licenceNr={
                      selectedVehicle ? selectedVehicle.licenceNr : "loading"
                    }
                    engineNr={
                      selectedVehicle ? selectedVehicle.engineNr : "loading"
                    }
                    make={selectedVehicle ? selectedVehicle.make : "loading"}
                    series={
                      selectedVehicle ? selectedVehicle.series : "loading"
                    }
                    notList={true}
                  />
                )}
              </div>
              {tableDisplay === "driverVehicles" ? null : (
                <div style={{ flex: 1, width: "100%" }}>
                  <DropDownWithDisplay
                    title={"MAKE"}
                    tagline={"(Select the make of your vehicle)"}
                    data={dummyMakes}
                    selected={selectedMake}
                    setSelected={setSelectedMake}
                    opened={opened}
                    setOpened={setOpened}
                    makeDropDown={true}
                  />
                  <TextInputField
                    mini={true}
                    labelTitle={"Series"}
                    width={"100%"}
                    size={"78%"}
                    marginTop={0}
                    value={selectedSeries}
                    onChange={(e) => setSelectedSeries(e.target.value)}
                    // reqiredCheck={true}
                    // rule={regsitrationNr.length}
                    // count={7}
                  />
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "78%",
                        marginTop: 40,
                        marginBottom: 20,
                        fontWeight: "bold",
                        fontSize: 16,
                      }}
                    >
                      LINKED USER
                    </div>
                    <TextInputField
                      mini={true}
                      labelTitle={"ID NUMBER"}
                      width={"100%"}
                      size={"78%"}
                      marginTop={0}
                      value={linkedUserIdNumber}
                      onChange={(e) => setLinkedUserIdNumber(e.target.value)}
                      // reqiredCheck={true}
                      // rule={regsitrationNr.length}
                      // count={7}
                    />
                  </div>
                  {/* <DropDownWithDisplay
                title={"SERIES"}
                tagline={"(Select your vehicles series)"}
                data={dummySeries}
                selected={selectedSeries}
                setSelected={setSelectedSeries}
                opened={opened}
                setOpened={setOpened}
                seriesDropDown={true}
              /> */}
                </div>
              )}

              {tableDisplay === "driverVehicles" ? (
                <div
                  style={{
                    height: 220,
                    width: "80%",
                    borderStyle: "solid",
                    marginLeft: 5,
                    borderRadius: 8,
                    marginTop: 20,
                    borderColor: colors.greenLight,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      marginTop: 10,
                      fontSize: 16,
                      fontWeight: "bold",
                      marginLeft: 10,
                      width: "95%",
                    }}
                  >
                    CURRENT OWNER
                  </div>

                  <TextInputField
                    mini={true}
                    labelTitle={"CONTACT NAME"}
                    width={"100%"}
                    size={"80%"}
                    readOnly={true}
                    value={vehicleOwner ? vehicleOwner.firstName : "loading"}
                  />
                  <TextInputField
                    mini={true}
                    labelTitle={"CONTACT INFO"}
                    width={"100%"}
                    size={"80%"}
                    readOnly={true}
                    value={vehicleOwner ? vehicleOwner.cellNumber : "loading"}
                  />
                </div>
              ) : null}
            </div>
            <div
              style={{
                flex: 0.5,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                // backgroundColor:colors.greenLight
              }}
            >
              <div
                style={{ marginBottom: 20, fontSize: 16, fontWeight: "bold" }}
              >
                BASIC INFORMATION
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  borderStyle: "solid",
                  borderWidth: 3,
                  borderColor: colors.greenLight,
                  width: "80%",
                  borderRadius: 8,
                  height: "56%",
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Registration Nr"}
                  width={"100%"}
                  size={"70%"}
                  marginTop={0}
                  readOnly={tableDisplay === "driverVehicles" ? true : false}
                  value={
                    tableDisplay === "driverVehicles"
                      ? selectedVehicle
                        ? selectedVehicle.registerNumber
                        : "loading"
                      : selectedVehicle
                      ? selectedVehicle.registerNr
                      : "loading"
                  }
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Vin Nr"}
                  width={"100%"}
                  size={"70%"}
                  readOnly={tableDisplay === "driverVehicles" ? true : false}
                  value={
                    tableDisplay === "driverVehicles"
                      ? selectedVehicle
                        ? selectedVehicle.vinNumber
                        : "loading"
                      : selectedVehicle
                      ? selectedVehicle.vinNr
                      : "loading"
                  }
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Licence Nr"}
                  width={"100%"}
                  size={"70%"}
                  readOnly={tableDisplay === "driverVehicles" ? true : false}
                  value={
                    tableDisplay === "driverVehicles"
                      ? selectedVehicle
                        ? selectedVehicle.liscenseNumber
                        : "loading"
                      : selectedVehicle
                      ? selectedVehicle.licenceNr
                      : "loading"
                  }
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Engine Nr"}
                  width={"100%"}
                  size={"70%"}
                  readOnly={tableDisplay === "driverVehicles" ? true : false}
                  value={
                    tableDisplay === "driverVehicles"
                      ? selectedVehicle
                        ? selectedVehicle.engineNumber
                        : "loading"
                      : selectedVehicle
                      ? selectedVehicle.engineNr
                      : "loading"
                  }
                />
              </div>
            </div>
          </div>
          {/* back and close buttons */}
          <div style={{ position: "absolute", top: 10, left: 10 }}>
            <BaseButtons
              label={"CLOSE"}
              width={100}
              backgroundColor={colors.secondaryOrange}
              onClick={() => {
                setActiveView("catalog");
                setVehicleOwner(null);
                setSelectedVehicle(null);
              }}
              borderRadius={10}
            />
          </div>
          {/* next and complete buttons */}
          <div style={{ position: "absolute", top: 10, right: 10 }}>
            {tableDisplay === "driverVehicles" ? (
              <div
                style={{
                  display: "flex",
                  // width: "80%",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  position: "absolute",
                  top: 0,
                  right: 0,
                }}
              >
                <BaseButtons
                  label={"VIEW HISTORY"}
                  borderRadius={8}
                  backgroundColor={colors.greenDark}
                  disabled={true}
                />
                <div style={{ width: 10 }} />
                <BaseButtons
                  label={"REQUEST INFORMATION"}
                  borderRadius={8}
                  backgroundColor={colors.greenDark}
                  width={150}
                  disabled={true}
                />
                <div style={{ width: 10 }} />
                <BaseButtons
                  label={"REQUEST ACCESS"}
                  borderRadius={8}
                  backgroundColor={colors.greenDark}
                  disabled={true}
                />
              </div>
            ) : (
              <div style={{ display: "flex" }}>
                <BaseButtons
                  label={"VEHICLE PARTICULARS"}
                  width={200}
                  backgroundColor={colors.greenLight}
                  borderRadius={10}
                  onClick={() => setVehicleDataTabDisplay("particulars")}

                  // onClick={() => SubmitHandler()}
                />
                <div style={{ minWidth: 10 }} />
                <BaseButtons
                  label={"SAVE CHANGES"}
                  width={140}
                  backgroundColor={colors.greenLight}
                  borderRadius={10}
                  onClick={() => updateVehicleBasic()}
                />
              </div>
            )}
          </div>
          <div
            style={{
              position: "absolute",
              top: 20,
              fontSize: 18,
              fontWeight: "bold",
              color: colors.secondaryDarkBlue,
              left: 140,
            }}
          >
            {tableDisplay === "driverVehicles"
              ? "USER REGISTERED VEHICLE"
              : "MANAGE VEHICLE ENATIS DATA"}
          </div>
        </div>
      ) : null}

      {vehicleDataTabDisplay === "particulars" ? (
        <div style={{ flex: 1, width: "100%" }}>
          <div style={{ position: "absolute", top: 10, left: 10 }}>
            <BaseButtons
              label={"CLOSE"}
              width={100}
              backgroundColor={colors.secondaryOrange}
              onClick={() => setVehicleDataTabDisplay("standard")}
              borderRadius={10}
            />
          </div>
          <div style={{ position: "absolute", top: 10, right: 10 }}>
            {tableDisplay === "driverVehicles" ? (
              <div
                style={{
                  display: "flex",
                  // width: "80%",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  position: "absolute",
                  top: 0,
                  right: 0,
                }}
              >
                <BaseButtons
                  label={"VIEW HISTORY"}
                  borderRadius={8}
                  backgroundColor={colors.greenDark}
                  disabled={true}
                />
                <div style={{ width: 10 }} />
                <BaseButtons
                  label={"REQUEST INFORMATION"}
                  borderRadius={8}
                  backgroundColor={colors.greenDark}
                  width={150}
                  disabled={true}
                />
                <div style={{ width: 10 }} />
                <BaseButtons
                  label={"REQUEST ACCESS"}
                  borderRadius={8}
                  backgroundColor={colors.greenDark}
                  disabled={true}
                />
              </div>
            ) : (
              <div style={{ display: "flex" }}>
                <div style={{ minWidth: 10 }} />
                {vehicleParticularsCheckData ? (
                  <BaseButtons
                    label={"SAVE CHANGES"}
                    width={140}
                    backgroundColor={colors.greenLight}
                    borderRadius={10}
                    onClick={() => updateNewParticulars()}
                    // onClick={() => SubmitHandler()}
                  />
                ) : (
                  <BaseButtons
                    label={"UPLOAD DATA"}
                    width={140}
                    backgroundColor={colors.greenLight}
                    borderRadius={10}
                    onClick={() => createNewParticulars()}
                  />
                )}
              </div>
            )}
          </div>
          <div
            style={{
              // borderStyle: "solid",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              maxHeight: height - 60,
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            <div style={{ width: "90%", marginTop: 80 }}>
              <div style={{ marginBottom: 10, fontWeight: "bold" }}>
                BASIC VEHICLE DETAILS
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Licence Number"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={licenceNumber}
                  onChange={(e) => setLicenceNumber(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Chassis number / VIN"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={chassisNumber}
                  onChange={(e) => setChassisNumber(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Vehicle Register Number"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={vehicleRegisterNumber}
                  onChange={(e) => setVehicleRegisterNumber(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Engine Number"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={engineNumber}
                  onChange={(e) => setEngineNumber(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Previous Licence Number"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={previousLicenceNumber}
                  onChange={(e) => setPreviousLicenceNumber(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Pre-Previous Licence Number"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={prepreviousLicenceNumber}
                  onChange={(e) => setPrePreviousLicenceNumber(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
            </div>
            <div style={{ width: "90%", marginTop: 30 }}>
              <div style={{ marginBottom: 10, fontWeight: "bold" }}>
                VEHICLE PARTICULARS
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Make"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={selectedMake}
                  onChange={(e) => setSelectedMake(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Tare (kg)"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={tareKg}
                  onChange={(e) => setTareKg(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Series"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={selectedSeries}
                  onChange={(e) => setSelectedSeries(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />

                <TextInputField
                  mini={true}
                  labelTitle={"Gross Vehicle Mass (GVM) (kg)"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={grossVehicleMassKg}
                  onChange={(e) => setGrossVehicleMassKg(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Model Derivitive"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={modelDerivitive}
                  onChange={(e) => setModelDerivitive(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Category"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Colour"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={colour}
                  onChange={(e) => setColour(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Driven"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={driven}
                  onChange={(e) => setDriven(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Special Classification"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={specialClassifications}
                  onChange={(e) => setSpecialClassifications(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Description"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Usage"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={usage}
                  onChange={(e) => setUsage(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Licence Expiry"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={licenceExpiry}
                  onChange={(e) => setLicenceExpiry(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Vehicle State"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={vehicleState}
                  onChange={(e) => setVehicleState(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Licence Disc Number"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={licenceDiscNumber}
                  onChange={(e) => setLicenceDiscNumber(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Roadworthy Status"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={roadWorthStatus}
                  onChange={(e) => setRoadWorthyStatus(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Engine Capacity (cc)"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={engineCapacity}
                  onChange={(e) => setEngineCapcity(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Police Mark"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={policeMark}
                  onChange={(e) => setPoliceMark(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Local Licence Fee"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={localLicenceFee}
                  onChange={(e) => setLocalLicenceFee(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <div style={{ width: "100%" }} />
                <TextInputField
                  mini={true}
                  labelTitle={"Locality Of Vehicle Record"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={localityOfVehicleRecord}
                  onChange={(e) => setLocalityOfVehicleRecord(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Police Clearance status"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={policeClearanceStatus}
                  onChange={(e) => setPoliceClearanceStatus(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Owner Type"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={ownerType}
                  onChange={(e) => setOwnerType(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Owner Status"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={ownerStatus}
                  onChange={(e) => setOwnerStatus(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Ownership Start Date"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={ownershipStartDate}
                  onChange={(e) => setOwnershipStartDate(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Name"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Identification Number"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={identificationNumber}
                  onChange={(e) => setIdentificationNumber(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Identification Type"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={identificationType}
                  onChange={(e) => setIdentificationType(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Address"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <TextInputField
                  mini={true}
                  labelTitle={"Report Date "}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={reportDate}
                  onChange={(e) => setReportDate(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Document Date"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={documentDate}
                  onChange={(e) => setDocumentDate(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />
              </div>
              <ImageUploadAWS
                onChange={(e) => handleFileChange(e)}
                labelTitle={"UPLOAD IMAGE"}
                mini={true}
                errorDisplay={imageError}
              />
            </div>
            <div style={{ minHeight: 80 }} />
          </div>
          <div
            style={{
              position: "absolute",
              top: 20,
              fontSize: 18,
              fontWeight: "bold",
              color: colors.secondaryDarkBlue,
              left: 140,
            }}
          >
            ENATIS VEHICLE PARTICULARS
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ManageVehiclePopUp;
